import { useEffect, useState } from "react";

/**
 * Navigazione minimale basata su hash (#/g/42): funziona su qualunque hosting
 * statico e il tasto "indietro" torna alla schermata precedente.
 */
/** Viste dell'elenco gare (#/gare/scadute) e filtro rapido (#/gare/attive?filtro=da-valutare). */
export type VistaGare = "attive" | "scadute" | "archiviate";
export type FiltroRapido = "da-valutare" | "cartelle-da-creare" | "in-scadenza";

export type Route =
  | { name: "home" }
  | { name: "gare"; vista: VistaGare; filtro?: FiltroRapido }
  | { name: "nuova" }
  | { name: "nuovo-albo" }
  | { name: "albi"; archiviati: boolean }
  | { name: "servizi" }
  | { name: "report" }
  | { name: "modello-checklist" }
  | { name: "checklist"; id: number }
  | { name: "gara"; id: number }
  | { name: "modifica"; id: number }
  | { name: "cartelle"; id: number };

export function parseRoute(hash: string): Route {
  const [path = "", query = ""] = hash.replace(/^#/, "").split("?");
  const parts = path.split("/").filter(Boolean);
  if (parts[0] === "gare") {
    const vista = (["attive", "scadute", "archiviate"] as const).find((v) => v === parts[1]) ?? "attive";
    const f = new URLSearchParams(query).get("filtro");
    const filtro = (["da-valutare", "cartelle-da-creare", "in-scadenza"] as const).find((x) => x === f);
    return { name: "gare", vista, filtro };
  }
  if (parts[0] === "nuova") return { name: "nuova" };
  if (parts[0] === "nuovo-albo") return { name: "nuovo-albo" };
  if (parts[0] === "albi") return { name: "albi", archiviati: parts[1] === "archiviati" };
  if (parts[0] === "servizi") return { name: "servizi" };
  if (parts[0] === "report") return { name: "report" };
  if (parts[0] === "modello-checklist") return { name: "modello-checklist" };
  if (parts[0] === "g" && parts[1]) {
    const id = Number(parts[1]);
    if (parts[2] === "modifica") return { name: "modifica", id };
    if (parts[2] === "cartelle") return { name: "cartelle", id };
    if (parts[2] === "checklist") return { name: "checklist", id };
    return { name: "gara", id };
  }
  return { name: "home" };
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const onChange = () => {
      setRoute(parseRoute(window.location.hash));
      window.scrollTo(0, 0);
    };
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}

export const navigate = (path: string) => {
  window.location.hash = path;
};

/** Sostituisce la voce corrente (es. dopo un salvataggio, così "indietro" non riapre il modulo). */
export const replace = (path: string) => {
  window.location.replace(`${window.location.pathname}${window.location.search}#${path}`);
};

export const goBack = (fallback = "/") => {
  if (window.history.length > 1) window.history.back();
  else navigate(fallback);
};
